import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import report from './report'
import axios from 'axios'
import attendance from './attendance'

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URI

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth,        
        report,
        attendance
    }
})